import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateClosedLeadFollowupAutomation as CreateClosedLeadFollowupAutomationMutation,
    CreateClosedLeadFollowupAutomationVariables,
    FollowupLeadAutomationCreateInput,
} from 'nutshell-graphql-types';

import CREATE_CLOSED_LEAD_FOLLOWUP_AUTOMATION from '../mutations/create-closed-lead-followup-automation.graphql';

export const useCreateClosedLeadFollowupAutomation = (): {
    createClosedLeadFollowupAutomation: (arg1: FollowupLeadAutomationCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createClosedLeadFollowupAutomation, {loading, error}] = useMutation<
        CreateClosedLeadFollowupAutomationMutation,
        CreateClosedLeadFollowupAutomationVariables
    >(CREATE_CLOSED_LEAD_FOLLOWUP_AUTOMATION);

    return {
        createClosedLeadFollowupAutomation: (input: FollowupLeadAutomationCreateInput) =>
            createClosedLeadFollowupAutomation({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
